<template>
  <el-container>
    <el-aside>
      <el-container>
        <aside-table @active="active" :userinfo="userinfo"></aside-table>
      </el-container>
    </el-aside>
    <el-main class="m-main">
      <el-container class="m-main-c">
        <el-header>
          <el-input
            placeholder="用户姓名"
            v-model="queryUserInfoParams.keywords"
            class="m-h-i"
          ></el-input>
          <el-button type="primary" @click="queryUserInfo(true)">查询</el-button>
        </el-header>
        <el-main>
          <el-table
            :data="userInfoList"
            border
            :header-cell-style="{ background: '#409EFF', color: '#fff' }"
            row-key="id"
            :tree-props="{ children: 'children' }"
          >
            <el-table-column prop="username" label="姓名"></el-table-column>
            <el-table-column prop="phoneNum" label="电话"></el-table-column>
            <el-table-column prop="icCardId" label="IC卡号"></el-table-column>
            <el-table-column
              prop="buildNum"
              label="位置（栋-单元）"
            ></el-table-column>
            <el-table-column prop="houseNum" label="房号"></el-table-column>
            <el-table-column label="认证状态">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.status == 2"
                  >审核通过</el-tag
                >
                <el-tag type="info" v-if="scope.row.status == 0">未提交</el-tag>
                <el-tag type="warning" v-if="scope.row.status == 1"
                  >待审核</el-tag
                >
                <el-tag type="danger" v-if="scope.row.status == 3"
                  >审核未通过</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200px">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  v-if="!scope.row.icCardId"
                  @click="addIcCard(scope.row)"
                  >添加IC卡</el-button
                >
                <el-button
                  type="warning"
                  v-if="scope.row.icCardId && scope.row.icCardStatus == 0"
                  @click="icReportLoss(scope.row)"
                  >挂失</el-button
                >
                <el-button
                  type="info"
                  v-if="scope.row.icCardStatus == 1"
                  @click="icReportLoss(scope.row)"
                  >取消挂失</el-button
                >
                <el-button
                  type="danger"
                  v-if="scope.row.icCardId"
                  @click="icLogout(scope.row)"
                  >注销</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-dialog
            width="30%"
            title="添加IC卡"
            :visible.sync="addIcCardIdStatus"
          >
            <el-input
              v-model="addIcCardIdData.icCardId"
              class="add-i"
              ref="getFocus"
              placeholder="请输入IC卡号"
            ></el-input>
            <p>
              <el-button type="danger" @click="addIcCardIdStatus = false"
                >取消</el-button
              >
              <el-button type="primary" @click="sureAddIcCardId()"
                >确定</el-button
              >
            </p>
          </el-dialog>
        </el-main>
        <el-footer>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryUserInfoParams.start"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="queryUserInfoParams.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </el-footer>
      </el-container>
    </el-main>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
import AsideTable from "../modules/aside-table";
export default {
  components: { AsideTable },
  data() {
    return {
      housingId: "",
      total: 0,
      queryUserInfoParams: {
        start: 1,
        pageSize: 10,
        keywords: "",
      },
      userInfoList: [], //
      addIcCardIdStatus: false, //添加弹框
      addIcCardIdData: {
        icCardId: ""
      }
    };
  },
  computed: {
    ...mapGetters(["userinfo"])
  },
  created() {},
  mounted() {},
  methods: {
    /*
     **  @description 分页
     **  @param {}
     **  @return
     **  @author shipingan
     */
    handleSizeChange(val) {
      this.queryUserInfoParams.pageSize = val;
    },
    handleCurrentChange(val) {
      this.queryUserInfoParams.start = val;
    },
    /*
     **  @description 子组件传值
     **  @param {}
     **  @return
     **  @author shipingan
     */
    active(row) {
      this.housingId = row.userId;
      this.queryUserInfo();
    },
    /*
     **  @description 查询用户
     **  @param {}
     **  @return
     **  @author shipingan
     */
    queryUserInfo(val) {
      if (val) {
        this.queryUserInfoParams.start = 1
      }
      let url = "/dapi/u/listHousingInfo",
      params = { ...this.queryUserInfoParams };
      params.housingId = this.housingId;
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.total = data.data.total;
          this.userInfoList = data.data.pageInfo;
        } else {
          this.$message.error(data.message);
        }
      });
    },
    /*
     **  @description 添加IC卡
     **  @param {}
     **  @return
     **  @author shipingan
     */
    addIcCard(row) {
      this.addIcCardIdData.userHouseId = row.id;
      this.addIcCardIdData.userName = row.username;
      this.addIcCardIdData.userLoginId = row.userLoginId;
      this.addIcCardIdData.uid = this.userinfo.uid;
      this.addIcCardIdStatus = true;
      this.$nextTick(() => {
        this.$refs.getFocus.focus();
      });
    },
    sureAddIcCardId() {
      let url = "/dapi/u/addICCardIdByUserLoginIdOrIdNum";
      let params = { ...this.addIcCardIdData };
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(res => {
          let data = res.data;
          if (data.status == 200) {
            this.$message({
              type: "success",
              message: "添加成功"
            });
            this.addIcCardIdData.icCardId = "";
            this.queryUserInfo();
            this.addIcCardIdStatus = false;
          } else {
            this.$message.error(data.message);
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    /*
     **  @description 注销--挂失
     **  @param {}
     **  @return
     **  @author shipingan
     */
    icReportLoss(row) {
      let params = {
        userHouseId: row.id,
        icCardStatus: row.icCardStatus == 0 ? 1 : 0
      };
      this.$confirm("确定将此用户IC卡挂失吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios
            .post("/dapi/u/userReportLoss", this.$qs.stringify(params))
            .then(res => {
              let data = res.data;
              if (data.status == 200) {
                this.$message({
                  type: "success",
                  message: "挂失成功"
                });
                this.queryUserInfo();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    icLogout(row) {
      let params = { userHouseId: row.id };
      this.$confirm("确定将此用户IC卡注销吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios
            .post("/dapi/u/userIcLogout", this.$qs.stringify(params))
            .then(res => {
              let data = res.data;
              if (data.status == 200) {
                this.$message({
                  type: "success",
                  message: "注销成功"
                });
                this.queryUserInfo();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    }
  }
};
</script>
<style lang="less" scoped>
@box-shadow: 0 0 10px #ccc;
.el-container {
  height: 100%;
}
.el-aside {
  box-shadow: @box-shadow;
}
.m-main {
  padding: 0;
}
.m-main-c {
  .el-header {
    box-shadow: @box-shadow;
    line-height: 60px;
    text-align: left;
    .m-h-i {
      width: 200px;
      margin-right: 10px;
    }
  }
}
.add-i {
  width: 80%;
}
</style>
